<ion-header>
  <ion-toolbar mode="md"
               color="dark">
    <ion-title>{{ 'payment.creditCardTransaction' | transloco }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <div class="gateway-transaction">
    <div *ngIf="view === 'in_progress'">
      <img src="assets/image/payments/gateway-in-progress.png">
      <h1>{{ 'payment.paymentRequestInProgress' | transloco }}</h1>
      <p *ngIf="!(lastGatewayTransaction$ | async).collect_manual_card_entry_on_pinpad">{{
        'payment.instructGuestFollowPrompts' | transloco }}</p>

      <div *ngIf="showCancelTransactionButton$ | async">
        <ion-button color="danger"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onCancelTransaction()">{{ 'payment.cancelTransaction' | transloco }}</ion-button>
      </div>
    </div>

    <div *ngIf="view === 'success'">
      <img src="assets/image/payments/gateway-complete.svg">
      <h1>{{ 'payment.approved' | transloco }}</h1>
      <p>{{ 'payment.ensureCardRemovedProvideReceipt' | transloco }}</p>
      <div class="gateway-transaction__summary">
        <div class="gateway-transaction__summary-row">
          <label>{{ 'pos.subtotal' | transloco }}</label>
          <label>{{ paymentAmount | currency }}</label>
        </div>
        <div class="gateway-transaction__summary-row" *ngIf="tipAmount > 0">
          <label>{{ 'pos.tip' | transloco }}</label>
          <label>{{ tipAmount | currency }}</label>
        </div>
        <div class="gateway-transaction__summary-row gateway-transaction__summary-row--total">
          <label>{{ 'pos.total' | transloco }}</label>
          <label>{{ totalCharged | currency }}</label>
        </div>
      </div>
      <div>
        <ion-button debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onModalDismiss()"
                    color="dark">{{ 'common.close' | transloco }}</ion-button>
      </div>
    </div>
    <div *ngIf="view === 'error'">
      <img src="assets/image/payments/gateway-error.png">
      <h1>{{ 'payment.paymentNotCompleted' | transloco }}</h1>

      <ng-container *ngIf="gatewayError">
        <p *ngIf="gatewayError.cmdStatus as cmdStatus" class="ion-text-center">
          {{ 'payment.cmdStatus' | transloco }}: {{cmdStatus}}
        </p>
        <p *ngIf="gatewayError.message as textResponse" class="ion-text-center">
          {{ 'payment.textResponse' | transloco }}: {{ textResponse }}
        </p>
      </ng-container>

      <div>
        <ion-button debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onRetry()"
                    color="dark">{{ 'errors.tryAgain' | transloco }}</ion-button>
        <ion-button debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onModalDismiss()"
                    color="danger">{{ 'common.cancel' | transloco }}</ion-button>
      </div>
    </div>
  </div>
</ion-content>